import * as actionTypes from 'setup/redux/DattaThemeOptions'

import React, {Component} from 'react';

import NavLeft from './NavLeft'
import NavRight from './NavRight'
import {connect} from 'react-redux';
import { Image } from 'antd'
import Logo_ssc from '../../../../assets/images/Logo_ssc.png';
import Logo_evision from '../../../../assets/images/Logo_evision.png';
import Logo_song from '../../../../assets/images/Logo_song.png';
import Logo_hapu from '../../../../assets/images/Logo_hapu.png';
import Logo_aha from '../../../../assets/images/Logo_aha.png';
import Logo_max_media from '../../../../assets/images/Logo_max_media.png';
import Logo_loc from '../../../../assets/images/Logo_loc.png';
import Logo_quangtri from '../../../../assets/images/Logo_quangtri.png';
import Logo_aha_manual from '../../../../assets/images/Logo_aha_manual.png';

class NavBar extends Component {
  render() {
    let headerClass = ['navbar', 'pcoded-header', 'navbar-expand-lg', this.props.headerBackColor]
    if (this.props.headerFixedLayout) {
      headerClass = [...headerClass, 'headerpos-fixed']
    }

    let toggleClass = ['mobile-menu']
    if (this.props.collapseMenu) {
      toggleClass = [...toggleClass, 'on']
    }

    let vendor = process.env.REACT_APP_VENDOR;

    return (
      <>
        <header className={headerClass.join(' ')}>
          <div className='m-header'>
            <a
              className={toggleClass.join(' ')}
              id='mobile-collapse1'
              href='!#'
              onClick={this.props.onToggleNavigation}
            >
              <span />
            </a>
            <a href='!#' className='b-brand'>
              {
                vendor === 'ssc' ? (
                  <Image src={Logo_ssc} preview='false' />
                ) : vendor === 'evision' ? (
                  <Image preview='false' src={Logo_evision}/>
                ) : vendor === 'aha' ? (
                  <Image preview='false' style={{ borderRadius: '5px' , width: '70px'}} src={Logo_aha}/>
                ) : vendor === 'hapu' ? (
                  <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_hapu}/>
                ) : vendor === 'max_media' ? (
                  <Image preview='false' style={{ borderRadius: '5px' , width: '35px'}} src={Logo_max_media}/>
                ) : vendor === 'loc' ? (
                  <Image preview='false' style={{ borderRadius: '5px' , width: '35px'}} src={Logo_loc}/>
                ) : vendor === 'aha_manual' ? (
                  <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_aha_manual}/>
                ) : vendor === 'quangtri' ? (
                  <Image preview='false' style={{ borderRadius: '5px' , width: '40px'}} src={Logo_quangtri}/>
                ) : (
                  <Image preview='false' style={{ borderRadius: '5px' , width: '70px'}} src={Logo_song}/>
                )
              }
              <span className='b-title text-white'>{process.env.REACT_APP_NAME}</span>
            </a>
          </div>
          <a className='mobile-menu' id='mobile-header' href='!#'>
            <i className='feather icon-more-horizontal' />
          </a>
          <div className='collapse navbar-collapse'>
            <NavLeft {...this.props}/>
            <NavRight rtlLayout={this.props.rtlLayout} />
          </div>
        </header>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    rtlLayout: state.DattaThemeOptions.rtlLayout,
    headerBackColor: state.DattaThemeOptions.headerBackColor,
    headerFixedLayout: state.DattaThemeOptions.headerFixedLayout,
    collapseMenu: state.DattaThemeOptions.collapseMenu,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleNavigation: () => dispatch({type: actionTypes.COLLAPSE_MENU}),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar)
